<template>
  <div class="min-h-screen bg-gray-50 px-4 pt-6 pb-28" dir="rtl">
    <div class="max-w-2xl mx-auto space-y-4">
      <div class="bg-white rounded-xl border border-gray-200 p-5 space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('groupName') }}</label>
          <input
            type="text"
            v-model="group_name"
            :placeholder="$t('groupName')"
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
          />
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('groupId') }}</label>
          <input
            type="text"
            v-model="group_enName"
            :placeholder="$t('groupIdEnglish')"
            @keypress="isLetter($event)"
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
          />
          <p v-if="check_msg" class="mt-2 text-xs text-gray-500">{{ check_msg }}</p>
        </div>
      </div>

      <div class="bg-white rounded-xl border border-gray-200 p-5">
        <p class="text-sm font-medium text-gray-700 mb-3">{{ $t('selectTwoMember') }}</p>

        <div class="space-y-2 mb-4">
          <div
            v-for="(item, i) in items"
            :key="item.UserContactId"
            class="flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-all duration-200"
            :class="item.IsSelected ? 'border-blue-500 bg-blue-50 ring-1 ring-blue-200' : 'border-gray-200 hover:border-blue-300'"
            @click="select_contact(i)"
          >
            <img
              :src="item.ImageUrl || '/img/avatar.jpg'"
              alt=""
              class="w-10 h-10 rounded-full object-cover border border-gray-200 flex-shrink-0"
            />
            <div class="flex-1 min-w-0">
              <p class="text-sm font-semibold text-gray-900 truncate">{{ item.UserName }}</p>
              <p class="text-xs text-gray-500 truncate">{{ item.UserCode }}</p>
            </div>
            <div
              class="w-5 h-5 rounded-full border flex items-center justify-center flex-shrink-0"
              :class="item.IsSelected ? 'bg-blue-600 border-blue-600' : 'border-gray-300'"
            >
              <svg v-if="item.IsSelected" class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>
        </div>

        <button
          type="button"
          class="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-3 px-6 rounded-lg font-semibold transition-all duration-200"
          @click="addGroup()"
        >
          {{ $t('add') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from '../../main'

export default {
  data () {
    return {
      items: '',
      isSelect: false,
      phone: '',
      password: '',
      lastItemId: 0,
      lastLogId: 0,
      group_name: '',
      group_enName: '',
      selectedItem: [],
      check_msg: '',
      check_flag: false,
    }
  },
  watch: {
    group_enName : function (val) {
      const param = {
        Code:  val
      }
      this.axios.post('/CheckExistsCode', param, {})
        .then(response => {
          if (response.data.error == 0) {
            console.log('CheckExistsCode ', response.data)
            this.check_msg = response.data.msg
            this.check_flag = true
          } else {
            bus.$emit('show_toast', [1500, response.data.msg])
          }
        }).catch(e => {

      })
    }

  },
  methods: {
    isLetter (e) {
      const char = String.fromCharCode(e.keyCode)
      if (/^[a-zA-Z0-9_]+$/.test(char)) return true
      else e.preventDefault()
    },
    select_contact (i) {
      this.selectedItem = []
      var data = this.items[i]
       if (data.IsSelected == true) {
         data.IsSelected = false
         this.items.splice(i, 1, data)
       } else {
         data.IsSelected = true
         this.items.splice(i, 1, data)
       }
      for (var j = 0; j < this.items.length; j++) {
        if (this.items[j].IsSelected == true) {
          const selectObj = {
            MemberId: this.items[j].UserContactId,
            MemberName : this.items[j].UserName
          }
          this.selectedItem.push(selectObj)
        }
      }
      console.log('this.selectedItem :' + JSON.stringify(this.items))
      console.log('this.selectedItem :' + i)
    },
    getAllContacts () {
      this.phone = localStorage.getItem('phone')
      this.password = localStorage.getItem('password')
      const send_data = {
        Phone:this.phone,
        Password: this.password,
        LastItemId: this.lastItemId,
        LastLogId: this.lastLogId
      }
      this.axios.post('/ShowAllGroupContacts', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            this.items = response.data.contacts
            for (var i = 0; i < this.items.length; i++) {
              this.items[i].IsSelected = false
              console.log('test :' + JSON.stringify(this.items[i]))
            }
          }
        }).catch(e => {

      })
    },


    addGroup () {
      if (this.check_flag) {
        var user_data = JSON.parse(localStorage.getItem('profile'))
        if (this.group_enName.startsWith('@') == false) {
          var str1 = '@'
          var eName = str1.concat(this.group_enName)
        } else {
          var eName = this.group_enName
        }

        const send_data = {
          GroupName:this.group_name,
          GroupCode: eName,
          OwnerId: user_data.UserId,
          OwnerName: user_data.UserName,
          Password: this.password,
          Members: this.selectedItem,
        }
        this.axios.post('/AddGroup', send_data, {})
          .then(response => {
            if (response.data.error == 0) {

              bus.$emit('show_toast', [1500, response.data.msg])
            } else {
              bus.$emit('show_toast', [1500, response.data.msg])
            }
          }).catch(e => {

        })
      }
    }

  },
  mounted () {
    this.getAllContacts()
  }
}
</script>
